import { RecognitionReport } from "@/components/reviews/RecognitionReport";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

/** Recognition surfaced across one round — EPIC-074. */
export function RecognitionReportPage() {
  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: "Recognition Report" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title="Recognition Report"
        description="Endorsements and top criterion scores for one round, HR's view of who stood out."
      />
      <RecognitionReport />
    </div>
  );
}
